<template>
  <div></div>
</template>

<script lang="ts" setup>
import { onBeforeUnmount } from 'vue'
import { useScript, useHead } from '@unhead/vue'

import { isClient } from '/@shared/app'

import { fxEvents } from '/@/utils'

useHead({
  link: [
    {
      key: 'crisp-preconnect',
      rel: 'preconnect',
      href: 'https://client.crisp.chat',
    },
  ],
})

useScript(
  {
    key: 'crisp-chat',
    defer: true,
    src: 'https://client.crisp.chat/l.js',
    tagPosition: 'bodyClose',
  },
  {
    beforeInit() {
      if (!isClient) return

      window.$crisp = []
      window.$crisp.push(['safe', true])
      window.CRISP_WEBSITE_ID = '69c32df5-da57-4f73-9078-65bd8f3dda6b'

      // analitics
      let firstmsg = true

      window.$crisp.push('on', 'message:sent', function () {
        if (firstmsg) {
          fxEvents.sendUserEvent('interaction', 'chat', location.href)
          firstmsg = false
        }
      })
    },
    use() {
      return { $crisp: window.$crisp }
    },
  }
)
declare global {
  interface Window {
    $crisp: any[]
    CRISP_WEBSITE_ID: string
  }
}

onBeforeUnmount(() => {
  window.$crisp.push(['do', 'chat:hide'])
})
</script>
